import { render, staticRenderFns } from "./LoggedIn.vue?vue&type=template&id=220b0f0e"
import script from "./LoggedIn.vue?vue&type=script&lang=js"
export * from "./LoggedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports